import Container from '@/components/Container';
import { Link, useParams } from 'react-router-dom';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { compare } from './utils/compare.utils';
import classNames from 'classnames';

export default function ResourceTypesFilter({ resourceTypes }: { resourceTypes: Array<string> }) {
  const { type: typeParam } = useParams();

  return (
    <AnimatedFadeInComponent>
      <Container>
        <div className="col-span-12 mb-sh-60 flex flex-wrap items-center justify-center gap-5 lg:col-start-11 lg:col-end-3">
          {
            // ['All']
            //   .concat(resourceTypes)
            resourceTypes
              .filter((resouceType) => !compare('Guides', resouceType))
              .map((resourceType) => {
                const active = compare(typeParam, resourceType);
                const isAll = resourceType === 'All' && !typeParam;

                return (
                  <>
                    <Link
                      key={resourceType}
                      to={`/resource-hub/type/${resourceType}` || ''}
                      //   aria-current={item.current ? 'page' : undefined}
                      className={classNames('inline-flex items-center border-b-2 px-1 pt-1 font-cadiz text-sh-11-20', {
                        'border-transparent text-black-100 duration-700 ease-in-out hover:text-black-100': !active,
                        '!border-b-2 !border-blue-500 font-bold': active || isAll,
                      })}>
                      {resourceType}
                    </Link>
                  </>
                );
              })
          }
        </div>
      </Container>
    </AnimatedFadeInComponent>
  );
}
